import {
  Companion_instancevwupp4fz0ehs as Companion_instance,
  EntityType3jq9a4zvbs0nt as EntityType,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareEntityTypeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [EntityType__id_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function EntityType__id$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function EntityType__id$_get_name_$ref_6yyaed() {
  return (p0) => p0.i20();
}
function EntityType__id$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function EntityType__id$_get_serializer_$ref_h0h1tg() {
  return (p0) => p0.h2j();
}
function EntityType__id$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function EntityType__id$_get_annotations_$ref_e3740g() {
  return (p0) => p0.bz();
}
var EntityType__idClass;
function EntityType__id() {
  if (EntityType__idClass === VOID) {
    class $ {
      constructor() {
        EntityType__id_instance = this;
        var tmp = this;
        tmp.h5z_1 = lazy(EntityType__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5z_1 = lazy(EntityType__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5z_1 = lazy(EntityType__id$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.h5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EntityType__id$_get_name_$ref_6yyaed(), null);
        return tmp0.f2();
      }
      k5z(receiver) {
        return receiver.l5z_1;
      }
      k2j(receiver) {
        return this.k5z(receiver instanceof EntityType() ? receiver : THROW_CCE());
      }
      m5z(receiver, value) {
        return receiver.n5z(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EntityType() ? receiver : THROW_CCE();
        return this.m5z(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EntityType__id$_get_serializer_$ref_h0h1tg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EntityType__id$_get_annotations_$ref_e3740g(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'EntityType__id', VOID, VOID, [SerializableProperty()]);
    EntityType__idClass = $;
  }
  return EntityType__idClass;
}
var EntityType__id_instance;
function EntityType__id_getInstance() {
  if (EntityType__id_instance === VOID)
    new (EntityType__id())();
  return EntityType__id_instance;
}
//region block: exports
export {
  prepareEntityTypeFields as prepareEntityTypeFields2zn5hxn126pi0,
};
//endregion

//# sourceMappingURL=EntityTypeFields.mjs.map
